import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { signOut} from 'firebase/auth';

export default function Signout() {
    const navigate = useNavigate();
    navigate('/')
}